export enum devicesActionTypes {
  SET_LOGGER = 'set_logger',
  SET_SCANNER = 'set_scanner',
  SET_LOCKER = 'set_locker',
  UPDATE_SETTING_UP_SCANNERS = 'update_setting_up_scanners',
  UPDATE_SETTING_UP_LOCKER = 'update_setting_up_locker',
  RESET_DEVICES = 'reset_devices',
}
